module.exports = __webpack_public_path__ + "static/media/picpost.0b79741c.gif";